<template>
  <el-dialog
    :title="title || '用户之声 - 查看记录'"
    :visible.sync="dialogVisible"
    width="810px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    custom-class="full-feedback-dialog"
  >
    <div class="feedback-view-content" v-loading="loading" element-loading-text="数据加载中...">
      <!-- 反馈基本信息 -->
      <div v-if="feedbackData.feedback" class="feedback-info">
        <div class="info-row">
          <span class="label">反馈类型：</span>
          <span class="value">{{ feedbackData.feedback.fb_type === 'system' ? '系统问题' : feedbackData.feedback.fb_type === 'module' ? '功能建议' : '其他' }}</span>
          <span class="label" style="margin-left: 30px;">反馈标题：</span>
          <span class="value title-value" :title="feedbackData.feedback.title">{{ feedbackData.feedback.title }}</span>
        </div>
        <!-- 反馈描述 -->
        <div class="description-section">
          <span class="label">反馈描述：</span>
          <div class="description-content">{{ feedbackData.feedback.content }}</div>
        </div>
        <!-- 反馈附件 -->
        <div class="attachment-section" v-if="feedbackData.feedback.attachment && feedbackData.feedback.attachment.length > 0">
          <span class="label">反馈附件：</span>
          <div class="image-grid">
            <el-image
              v-for="(url, index) in feedbackData.feedback.attachment"
              :key="index"
              :src="url"
              :preview-src-list="feedbackData.feedback.attachment"
              :initial-index="index"
              fit="cover"
              class="image-item"
              lazy
            >
              <div slot="error" class="image-error">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
      </div>
      
      <!-- 回复分割线 -->
      <div v-if="feedbackData.feedback" class="reply-divider">
        <span class="divider-text">系统管理员回复</span>
      </div>
      
      <!-- 回复内容显示 -->
      <div v-if="feedbackData.feedback && feedbackData.notifications && feedbackData.notifications.length > 0" class="reply-display-section">
        <div class="reply-item">
          <span class="label">建议回复：</span>
          <div class="reply-content">{{ feedbackData.notifications[0].reply_message }}</div>
        </div>
          <!-- 回复附件 -->
          <div class="attachment-section" v-if="feedbackData.notifications[0].attachment.length > 0">
            <span class="label">回复附件：</span>
            <div class="image-grid">
              <el-image
                v-for="(url, index) in feedbackData.notifications[0].attachment"
                :key="index"
                :src="url"
                :preview-src-list="feedbackData.notifications[0].attachment"
                :initial-index="index"
                fit="cover"
                class="image-item"
                lazy
              >
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </div>
      <div v-else-if="feedbackData.feedback" class="no-reply">
        <p>暂无回复记录</p>
      </div>
    </div>
    
    <!-- 弹窗底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "FeedbackView",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    feedbackData: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 本地弹窗状态
      dialogVisible: this.visible
    }
  },
  watch: {
    // 监听父组件传递的visible变化
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    // 监听本地dialogVisible变化，通知父组件
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  },
  methods: {
    // 处理弹窗关闭
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="less">
.feedback-view-content {
  padding: 0px;
  min-height: 300px;
}

/* 基本信息样式 */
.feedback-info {
  margin-bottom: 20px;
}

.info-row {
  margin-bottom: 15px;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.label {
  color: #606266;
  font-weight: 500;
  flex-shrink: 0;
}

.value {
  color: #303133;
  flex-shrink: 0;
}

/* 标题显示样式 */
.title-value {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 540px;
}

/* 描述部分样式 */
.description-section {
  margin-bottom: 10px;
}

.description-content {
  margin-top: 10px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  line-height: 1.5;
  color: #303133;
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
}

/* 附件部分样式 */
.attachment-section {
  margin-bottom: 10px;
}

/* 图片网格布局 */
.image-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.image-item {
  width: 100%;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  ::v-deep .el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #c0c4cc;
  font-size: 24px;
}

/* 分割线样式 */
.reply-divider {
  position: relative;
  height: 1px;
  background-color: #e4e7ed;
  margin: 20px 0;
  
  .divider-text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 0 20px;
    font-size: 14px;
    color: #909399;
  }
}

/* 回复显示部分样式 */
.reply-display-section {
  margin-bottom: 20px;
}

.reply-item {
  margin-bottom: 10px;
  padding: 0px;
  border-radius: 4px;
}

.reply-header {
  margin-bottom: 10px;
  font-size: 12px;
  color: #909399;
}

.reply-content {
  margin-top: 10px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  line-height: 1.5;
  color: #303133;
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
}

/* 无回复提示样式 */
.no-reply {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}



/* 弹窗底部按钮样式 */
.dialog-footer {
  padding: 0px 20px;
  text-align: right;
}
</style>
<style lang="less">
/* 确保弹窗层级高于抽屉 */
.full-feedback-dialog {
  margin-top: 60px !important;
  .el-dialog__header {
    padding: 20px 15px 5px 20px;
  }
  .el-dialog__body {
    padding: 0px 20px;
  }
}
</style>